<template>
  <div class="table_wrapper">
    <div class="container-fluid thead">
      <slot name="thead" />
    </div>
    <div class="container-fluid tbody">
      <slot />
    </div>
    <div class="container-fluid tfoot">
      <slot name="tfoot" />
    </div>
  </div>
</template>

<script>
import '~style/components/table.scss'
export default {
  name: 'TableWrapper'
}
</script>
